import { redirect } from '@tanstack/react-router'
import { isAuthorizedAdmin, useAuthStore } from './session'

export function requireAdmin({ location }: { location: { href: string } }) {
  const { session, claims } = useAuthStore.getState()
  if (!session || !isAuthorizedAdmin(claims)) {
    throw redirect({
      to: '/login',
      search: { from: location.href },
    })
  }
}

export function redirectIfAuthed() {
  const { session, claims } = useAuthStore.getState()
  if (session && isAuthorizedAdmin(claims)) {
    throw redirect({ to: '/dashboard' })
  }
}
